// =============================================================================
// LedgerPass — Programmatic SEO Solutions
// =============================================================================
// Content lives in seoSolutions.json so the build-time prerender script
// (scripts/prerender.mjs) and the React app consume the same single source.
// Each entry becomes a prerendered static page at /solutions/<slug>/.
// =============================================================================

import solutionsData from './seoSolutions.json';

export interface SeoSolution {
  title: string;
  metaDesc: string;
  heroTitle: string;
  heroSub: string;
  atomicTitle: string;
  atomicBody: string;
}

export const seoSolutions: Record<string, SeoSolution> = solutionsData;
